import React from "react";

const ImageInput = ({ onChange, required, label, text, ...props }) => {
  return (
    <div className="relative w-max">
      {label && (
        <label className="label flex mb-2">
          <span className="text-sm font-semibold text-start px-1">
            {label}
            {required && <span className="text-error ml-1">*</span>}
          </span>
        </label>
      )}
      <input
        type="file"
        accept="image/*"
        onChange={onChange}
        className="absolute inset-0 opacity-0 cursor-pointer"
        {...props}
      />
      <button
        type="button"
        className="bg-blue-600 text-white px-4 py-2 rounded shadow hover:bg-blue-700"
      >
        {text}
      </button>
    </div>
  );
};

export default ImageInput;
